const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/8g7gdsn2jm701-UZ/image;s=644x461",
        title: "Решётки, перила, ограждения! Аккуратно+качественно!",
        price: "",
        location: "Ташкент, Яшнабадский район "
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/g3nlhe02laq73-UZ/image;s=644x461",
        title: "установка кондиционера ремонт заправки",
        price: "",
        location: "Ташкент, Чиланзарский район",
    }, {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/c0h38qhncya4-UZ/image;s=644x461",
        title: "Tekin va arzon udobniy litsenziya hamyonbob.",
        price: "",
        location: "Ташкент, Шайхантахурский район",
    },
]

export default data;